import { useDica } from '../ui/Dica.js';

/**
 * Barras horizontais. Portado de `hbars()` no protótipo.
 *
 * É o gráfico de ranking — mais vendidos, planos ativos, saídas por
 * categoria. Horizontal porque os rótulos são nomes ("Coca-Cola Zero
 * 350 ml", "Futvôlei 2x · R$ 160") e não cabem sob uma barra vertical
 * sem girar o texto.
 */

export interface ItemDeBarra {
  readonly nome: string;
  readonly valor: number;
  /** Já formatado: "186 un", "R$ 22.400". */
  readonly rotulo: string;
  readonly cor: string;
  readonly dica: string;
}

export function BarrasHorizontais({ itens }: { itens: readonly ItemDeBarra[] }) {
  const dica = useDica();
  const maximo = Math.max(...itens.map((i) => i.valor), 1);

  return (
    <div className="hbar">
      {itens.map((item) => (
        <div
          key={item.nome}
          onMouseEnter={(e) => dica.mostrar(e, { titulo: item.nome, texto: item.dica })}
          onMouseMove={(e) => dica.mover(e)}
          onMouseLeave={() => dica.esconder()}
        >
          <div className="l">
            <span>{item.nome}</span>
            <b className="num">{item.rotulo}</b>
          </div>
          <div className="track">
            <div
              className="fill"
              style={{ width: `${(item.valor / maximo) * 100}%`, background: item.cor }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
